/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type ArchiveSkillRequestBody = {
  /**
   * The skill ID.
   */
  id: string;
};

/** @internal */
export type ArchiveSkillRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const ArchiveSkillRequestBody$outboundSchema: z.ZodMiniType<
  ArchiveSkillRequestBody$Outbound,
  ArchiveSkillRequestBody
> = z.object({
  id: z.string(),
});

export function archiveSkillRequestBodyToJSON(
  archiveSkillRequestBody: ArchiveSkillRequestBody,
): string {
  return JSON.stringify(
    ArchiveSkillRequestBody$outboundSchema.parse(archiveSkillRequestBody),
  );
}
